/**
 * Detección de plataforma para el prompt de instalación. Funciones puras:
 * reciben los valores del entorno como parámetros para poder testearse.
 */

export function isIos(userAgent: string, maxTouchPoints: number): boolean {
  if (/iphone|ipad|ipod/i.test(userAgent)) return true;
  // iPadOS 13+ se anuncia como Macintosh pero expone pantalla táctil.
  return /macintosh/i.test(userAgent) && maxTouchPoints > 1;
}

export function isStandaloneDisplay(
  displayModeStandalone: boolean,
  navigatorStandalone: unknown,
): boolean {
  return displayModeStandalone || navigatorStandalone === true;
}
